export class AllMasterDatabaseModel {
    public id: number;
    public sha1: string;
    public sha256: string;
    public winOLSReference: string
    public masterFileBlobZipReference: string;
    public numberOfVersions: number;
    public uploadedBy: string;
    public dateUploaded: string;
    public vehicleType: string;
    public vehicleProducer: string;
    public vehicleSeries: string;
    public vehicleModel: string;
    public vehicleModelYear: string;
    public ecuUse: string;
    public ecuProducer: string;
    public ecuBuild: string;
    public ecuProdNr: string;
    public ecuSoftwareVersion: string;
    public ecuSoftwareVersionVersion: string;
    public engineName: string;
    public engineDisplacement: string;
    public vehicleBuild: string;
    public vehicleCharacteristic: string;
    public ecuStgNr: string;
    public ecuProcessor: string;
    public engineProducer: string;
    public engineType: string;
    public engineMaxTorque: string;
    public engineEmission: string;
    public engineGear: string;
    public projectCreatedBy: string;
    public projectChangedBy: string;
    public outputPs: string;
    public outputKw: string;
    public engineTransmission: string;
    public readingHardware: string;
    public additionalInfo: string;
    public projectComment: string;
    public versionComment: string;
    public  softwareNumber: string;
    public projectType:string;

    constructor() {
        this.id = 0;
        this.winOLSReference = "winOLSReference";
        this.ecuProducer = "ecuProducer";
        this.ecuBuild = "ecuBuild";
        this.engineName = "engineName";
        this.numberOfVersions = 0;
        this.dateUploaded = 'dateUploaded';
        this.vehicleType = "vehicleType";
        this.vehicleProducer = "vehicleProducer";
        this.vehicleSeries = "vehicleSeries";
        this.vehicleModel = "vehicleModel";
        this.vehicleModelYear = "vehicleModelYear";
        this.ecuUse = "ecuUse";
        this.ecuProdNr = "ecuProdNr";
        this.ecuSoftwareVersion = "ecuSoftwareVersion";
        this.ecuSoftwareVersionVersion = "ecuSoftwareVersionVersion";
        this.engineDisplacement = "engineDisplacement";
        this.vehicleBuild = "vehicleBuild";
        this.vehicleCharacteristic = "vehicleCharacteristic";
        this.ecuStgNr = "ecuStgNr";
        this.ecuProcessor = "ecuProcessor";
        this.engineProducer = "engineProducer";
        this.engineType = "engineType";
        this.engineMaxTorque = "engineMaxTorque";
        this.engineEmission = "engineEmission";
        this.engineGear = "engineGear";
        this.projectCreatedBy = "projectCreatedBy";
        this.projectChangedBy = "projectChangedBy";
        this.outputPs = "outputPs";
        this.outputKw = "outputKw";
        this.engineTransmission = "engineTransmission";
        this.readingHardware = "readingHardware";
        this.additionalInfo = "additionalInfo";
        this.uploadedBy = "uploadedBy";
        this.masterFileBlobZipReference = "masterFileBlobZipReference";
        this.sha1 = "sha1";
        this.sha256 = "sha256";
        this.projectComment = "projectComment";
        this.versionComment = "versionComment";
        this.softwareNumber = "softwareNumber";
        this.projectType = "projectType";
    }
}
